{
  "increasedQuantity": "จำนวนที่เพิ่ม",
  "decreasedQuantity": "จำนวนที่ลด",
  "rewardQuantity": "จำนวนรางวัล",
  "jbpSystemOrderNumber": "หมายเลขคำสั่งซื้อระบบ JBP",
  "walletTransactionNumber": "หมายเลขธุรกรรมกระเป๋าเงิน",
  "transactionId": "รหัสธุรกรรม (TxID)",
  "exchangeRate": "อัตราแลกเปลี่ยน",
  "exchangeRateFromUsdt": "1 USDT ≈ {{amount}} {{token}}",
  "transferInAmount": "จำนวนเงินที่โอนเข้า",
  "convertedAmount": "จำนวนที่แลกเปลี่ยน",
  "paymentQuantity": "จำนวนที่ชำระ",
  "receivedQuantity": "จำนวนที่รับ"
}
